import { oc } from '@orpc/contract';
import { estimateDetailSchema, getEstimateInputSchema } from '../schemas/estimates.schemas.js';
/** The estimate with its customer, template and policy versions, inspection, quick range and valuation. */
export const getEstimateContract = oc
    .route({
    method: 'GET',
    path: '/estimates/{estimateId}',
    tags: ['Estimates'],
    summary: 'Read one estimate',
})
    .input(getEstimateInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=get-estimate.contract.js.map